module.exports = __webpack_public_path__ + "static/img/20045B_2_R_20201106_fit.eba194f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20045B_2_R_20201106_fit.png
// module id = 72If
// module chunks = 0